import * as yup from 'yup';
import { BrandType, LinesCombinationsType, PythonType } from '../types';

export const createPythonDialogSchema = yup.object().shape({
  venueId: yup.string().nullable().default(null).label('Venue Id'),
  length: yup.number().required().label('Length'),
  type: yup.mixed<PythonType>().oneOf(Object.values(PythonType)).nullable().default(null).label('Type'),
  brand: yup.mixed<BrandType>().oneOf(Object.values(BrandType)).nullable().default(null).label('Brand'),
  linesComb: yup
    .mixed<LinesCombinationsType>()
    .oneOf(Object.values(LinesCombinationsType))
    .nullable()
    .default(null)
    .label('Lines combinations'),
  position: yup.number().required().label('Position'),
  barId: yup.string().required().label('Bar'),
  cellarId: yup.string().required().label('Cellar'),
  shouldShift: yup.boolean().nullable().default(null).label('Should Shift')
});

export const updatePythonDialogSchema = yup.object().shape({
  pythonId: yup.string().nullable().default(null).label('Python Id'),
  length: yup.number().required().label('Length'),
  venueId: yup.string().nullable().default(null).label('Venue Id'),
  type: yup.mixed<PythonType>().oneOf(Object.values(PythonType)).nullable().default(null).label('Type'),
  brand: yup.mixed<BrandType>().oneOf(Object.values(BrandType)).nullable().default(null).label('Brand'),
  linesComb: yup
    .mixed<LinesCombinationsType>()
    .oneOf(Object.values(LinesCombinationsType))
    .nullable()
    .default(null)
    .label('Lines combinations'),
  position: yup.number().required().label('Position'),
  barId: yup.string().required().label('Bar'),
  cellarId: yup.string().required().label('Cellar'),
  shouldShift: yup.boolean().nullable().default(null).label('Should Shift')
});
